module.exports = __webpack_public_path__ + "img/claimant_attendance_icon.b0705318.svg";